export default {
	text: {
		addButton: 'Hinzufügen',
		addFile: 'Anhang hinzufügen',
		addedFrom: 'Hinzugefügt von ',
		approveRequestButtonInfo: 'Anfrage genehmigen',
		area: 'Kreis',
		areaAssociation: 'Kreisverband',
		all: 'Alle',
		approvalStateItems: {
			created: 'erstellt',
			openForApproval: 'beantragt',
			editing: 'in Bearbeitung',
			approved: 'genehmigt',
			declined: 'abgelehnt',
			canceled: 'abgesagt',
		},
		allowedFormats: {
			jpg: 'JPEG-Datei (.jpeg, .jpg)',
			png: 'PNG-Datei (.png)',
			html: 'HTML-Datei (.html)',
			pdf: 'PDF-Datei (.pdf)',
			doc: 'Word-Dokument (.doc, .docx)',
			xls: 'Excel-Tabelle (.xls)',
			txt: 'Text-Datei (.txt)',
		},
		attachmentType: {
			text: 'Text',
			file: 'Datei',
			link: 'Link',
		},
		accept: 'Übernehmen',
		abort: 'abbrechen',
		abortUC: 'Abbrechen',
		abortNoSave: 'Abbrechen ohne Speichern',
		adjustDef: 'Definitionen anpassen',
		additionalFilter: 'erweiterte Filter',
		additionalConactInfo: 'Zusätzliche Kontaktinformationen',
		additionaltInfo: 'Zusätzliche Informationen',
		additionalConactInfoPlaceholder: 'z.B. zweiter Ansprechpartner, Erreichbarkeit Uhrzeit, etc...',
		addStreet: 'Zusatz',
		approval: 'Genehmigung',
		approve: 'Genehmigen',
		approceDecline: 'genehmigen/ablehnen',
		apply: 'Anlegen',
		bestPerfOnly: 'nur beste Leistung pro Athlet',
		backButton: 'Zurück',
		bestlist: 'Bestenliste',
		bestlistTitle: 'Bestenlisten',
		bestListsLoading: 'Bestenlisten laden',
		bestResult: 'Resultat',
		category: 'Kategorie',
		confirmTitle: 'Bestätigen',
		confirmation: 'Ihr Konto wurde erfolgreich bestätigt. Sie können sich jetzt einloggen',
		confirmPassword: 'Passwort bestätigen',
		createButton: 'Erstellen',
		createAndNew: 'Speichern und Neu',
		createAndScan: 'Speichern und Weiterscannen',
		createAndClose: 'Speichern und Schließen',
		createAndNext: 'Speichern und weiter',
		createCustom: 'selbst erstellen',
		createApprovalHint1: 'Mit dem Anschicken bestätigt der Veranstalter die Kenntnisnahme der <a href="https://www.dlv-event.de/Files/event-info.pdf" target="_blank">Hinweise</a> und verpflichtet sich zu Beachtung der dort angegebenen Auflagen sowie zur Einhaltung der DLV-Satzung und Ordnung, der darin enthaltenen DLV-Anti-Doping-Codes (ADC), der Deutschen Leichtathletikordnung (DLO), der Gebührenordnung (GBO) sowie zur Einhaltung der Internationalen Wettkampfregeln (IWR). Der Veranstalter verpflichtet sich des Weiteren, Teilnehmer seiner Veranstaltung schriftlich darauf hinzuweisen, dass dieser mir der Teilnahme die Geltungen des DLV-Anti-Doping-Codes (DLV-ADC) anerkennt und sich dessen Bestimmungen unterwirft. ',
		createApprovalHint2: 'Er erklärt sich auch damit einverstanden, dass vorgenannte Veranstaltung einschließlich der genannten Kontaktdaten in den DLV- und LV-Publikationen, sowie den Internetseiten www.leichthletik.de, www.laufen.de (nur Laufveranstaltungen) und des eigenen LV veröffentlicht werden kann, Dieses gilt auch für die Ergebnisse zur Erstellung von Bestenlisten.',
		createApprovalHint3: 'Hier können Sie Ausschreibung, Zeitplan und Ergebnislisten hochladen.',
		createApprovalHint4: 'Hierfür klicken Sie auf „Datei hinzufügen“ und wählen dann aus, ob Sie einen Link auf der Homepage eingeben, oder eine Datei hochladen wollen. Dann füllen Sie alle 4 offenen Felder aus. „Titel“ – so heißt die Datei/Link bei Veröffentlichung im Internet, unter „Gruppe“ wählen Sie das Themengebiet zu dem die Datei/Link gehört, „Sort“ steht für die Sortierreihenfolge in der die Daten/Links angezeigt werden sollen (1 = an erster Stelle usw.). Bei „Link“ tragen Sie den Link zu einer Homepage ein, bei „Datei“ laden Sie über „Durchsuchen“ eine Datei von Ihrem PC hoch oder bei „Text“ geben Sie den gewünschten Fließtext ein.',
		createApprovalHint5: 'Erlaubte Dateiformate sind:',
		compApprovalFinisherHint1: 'Bitte tragen Sie hier die Gesamtfinisher (über alle Disziplinen, Streckenlängen und Bewegungsformen) Ihrer Veranstaltung ein:',
		compApprovalFinisherHint2: 'Einmal erfasst, können die Finisherzahlen nur noch vom {LV} geändert werden!',
		compApprovalFinisherHint3: 'Bitte tragen Sie hier die Gesamtzahl Ihrer Veranstaltung ein:',
		compApprovalFinisherHint4: 'An welche Adresse solld ie Rechnung versendet werden?',
		createTime: 'Erstelldatum',
		competitionContact: 'Konzakt d. Veranstaltung',
		class: 'Klasse',
		cancel: 'absagen',
		classes: 'Klassen',
		classesSelected: ' Klassen ausgewählt',
		closingDate: 'Meldeschluss',
		checkingLoading: 'Ladevorgang prüfen',
		checkingTitle: 'Überprüfung',
		competition: 'Veranstaltung',
		competitions: 'Veranstaltungen',
		createdFrom: 'Erfasst von',
		createdOn: 'Erfasst am',
		copy: 'kopieren',
		copyFrom: 'Kopieren von',
		competitionId: 'WK-ID',
		competitionNotPassed: 'Die Veranstaltung ist noch nicht beendet',
		competitionFinisherRecorded: 'Finisher-Zahlen wurden bereits erfasst',
		competitionLocation: 'Veranstaltungsort',
		compApprovalBillingInfo: 'Sind Sie ein gemeinnütziger Veranstalter und werden alle Einnahmen aus Start/-Teilnehmergebühren der Veranstaltung unmittelbar mildtätigen Zwecken im Sinne von §53 AO, §4 Nr. 18 UStG zugeführt?',
		compApprovalBillingUsage: 'Mildtätigen Zweck angeben',
		compApprovalFeeInfo: 'Start-/Teilnehmergebühren werden erhoben',
		competitionApprovalRequest: 'Veranstaltung eintragen',
		company: 'Firma',
		competitionApproval: 'Wettkampfgenehmigung',
		competitionApprovalType: {
			all: 'Stadionfern - alle',
			nonStadiaMeasured: 'Stadionfern - vermessen',
			nonStadiaNonMeasured: 'Stadionfern - nicht vermessen',
			nonStadiaMixedMeasured: 'Stadionfern - gemischt',
		},
		competitionApprovalArt: {
			streetRun: 'Straßen-/Landschaftslauf',
			crossCountry: 'Cross-/Waldlauf',
			mountainRun: 'Berg-/Geländelauf',
			streetWalk: 'Straßengehen (Wettkampfgehen, kein Walking',
			else: 'Sonstige (Bsp: Trail, Adventure-Lauf, Duathlon...)',
		},
		competitionGroups: {
			w: 'Frauen',
			m: 'Männer',
			w20: 'WJU20/U18',
			m20: 'MJU20/U18',
			w16: 'WJU16/U14',
			m16: 'MJU16/U14',
			w12: 'WKU12 und jünger',
			m12: 'MKU12 und jünger',
			wsen: 'Seniorinnen',
			msen: 'Senioren',
			sumRun: 'davon Läufer',
			sumInline: 'davon Anzahl sonstige (z.B.: Inline, Wandern, ...)',
			sumNordic: 'davon Anzahl (Nordic-) Walker',
		},
		competitionApprovalTitle: 'Wettkampfgenehmigung',
		competitionApprovalCategorryArt: 'Kategorie und Art',
		competitionApprovalEvClMatrix: 'Event-Klassen Kombinationen',
		competitionApprovalEventClass: 'Klassen und Bewerbe',
		competitionApprovalAttachments: 'Datein und Links',
		competitionApprovalDetailView: 'Veranstaltungsdetails',
		competitionLoading: 'Veranstaltung wird geladen',
		competitionTitle: 'Veranstaltung',
		competitionCategory: {
			club_Sportfest: '1.1 Sportfest vereinsoffen',
			area_Championship: '2.1 Kreismeisterschaft',
			area_Sportfest: '2.2 Sportfest kreisoffen',
			district_Championship: '3.1 Bezirksmeisterschaft',
			district_Sportfest: '3.2 Sportfest bezirksoffen',
			region_Championship: '4.1 Landesmeisterschaft',
			region_Sportfest: '4.2 Sportfest landesoffen',
			region_Sportfest_Bordering: '4.4 Sportfest landesoffen + 1 weiterer LV',
			national_Championship: '5.1 Deutsche Meisterschaft',
			national_Sportfest: '5.2 Sportfest national',
			national_Invitational: '5.3 Einladungssportfest national',
			national_Runevent: '5.4 Laufveranstaltung',
			international_InvitationalWalking: '6.4 Einladungssportfest Gehen',
			international_Runevent: '6.6 Laufveranstaltung',
			iAAF_Runevent: '8.3 Internationale Laufveranstaltung mit EA- oder WA-LABEL',
		},
		confirm: {
			logoff: 'Wollen Sie sich wirklich ausloggen?',
		},
		createInvoice: 'Rechnung erstellen',
		courseLength: 'Streckenlänge',
		competitor: 'Athlet',
		club: 'Verein',
		country: 'Land',
		checking: 'Prüfe...',
		customEvents: 'Eigene Bewerbe',
		customEventLabels: {
			run: 'Lauf',
			walk: 'Walking',
			nordicWalking: 'Nordic Walking',
			mixedWalking: 'Walking/Nordic Walking (gleiche Streckenlänge)',
			hiking: 'Wandern',
			inlineSkating: 'Inline Skating',
			wheelChair: 'Rollstuhl',
			timeRun: 'Lauf auf Zeit',
			else: 'Sonstiges',
		},
		dashboardTitle: 'Digitale Stellplatzkarte',
		dashboard: 'Digitale Stellplatzkarte',
		deleteRolesButton: 'Löschen',
		delete: 'Löschen',
		deleteRequest: 'Wirklich Löschen?',
		dateFrom: 'Datum vom',
		dateTo: 'Datum bis',
		download: 'Herunterladen',
		declinePerf: 'Leistung für Bestenlisten ablehnen',
		declineChecking: 'Überprüfung ablehnen',
		district: 'Bezirk',
		differentRoute: 'Abweichende Anfahrtsadresse',
		date: 'Datum',
		districtAssociation: 'Bezirksverband',
		editTime: 'Editierdatum',
		email: 'Email',
		endAge: 'End-Alter',
		endDate: 'Enddatum',
		environment: 'Umgebung',
		errorInvalidInput: 'Eingabe ungültig',
		errorEmpty: 'darf nicht leer sein',
		errorFirstNameRequired: 'Vorname ist erforderlich',
		errorLastNameRequired: 'Nachname ist erforderlich',
		errorEmailRequired: 'E-Mail ist erforderlich',
		errorInvalidEmail: 'Muss eine gültige E-Mail sein',
		errorPasswordRequired: 'Passwort wird benötigt',
		errorConfirmPasswordRequired: 'Passwort bestätigen ist erforderlich',
		errorConfirmPasswordWrong: 'Passwörter müssen übereinstimmen',
		errorLanguageRequired: 'Sprache ist erforderlich',
		errorOrganizationRequired: 'Organisation ist erforderlich',
		errorRoleRequired: 'Rolle ist erforderlich',
		errorReasonRequired: 'Grund ist erforderlich',
		errorUserRequired: 'Benutzer erforderlich',
		errorNameRequired: 'Name ist erforderlich',
		errorCompetitorRequired: 'Teilnehmer erforderlich',
		errorBestResultRequired: 'Ergebnis erforderlich',
		errorShouldBeTime: 'Eingabe entspricht nicht dem richtigen Format (00:00:00.00)',
		errorShouldBeDecimal: 'Eingabe entspricht nicht dem richtigen Format (+/-00.00)',
		errorShouldBeNumber: 'Eingabe entspricht nicht dem richtigen Format (+0000)',
		errorEmailRegisteredForEvent: 'Die E-Mailadresse ist bereits für dieses Event angemeldet. Bitte prüfen Sie Ihre E-Mails',
		errorClassDefRequired: 'Klasse erforderlich',
		errorEventRequired: 'Event erforderlich',
		errorResultDate: 'Datum erforderlich',
		errorCompetitionRequired: 'Wettbewerb erforderlich',
		errorNationRequired: 'Nation erforderlich',
		errorEnvironmentRequired: 'Umgebung erforderlich',
		errorTownRequired: 'Stadt erforderlich',
		errorBadQR: 'Der QR-Code scheint Fehlerhaft zu sein',
		error404: 'Angeforderte Daten nicht gefunden, überprüfen Sie die Richtigkeit der eingegebenen Daten',
		error403: 'Sie haben keinen Zugriff auf diese Ressource',
		error400: 'Falsche Daten, bitte überprüfen Sie die Richtigkeit der Daten',
		error422: 'Nicht verarbeitbare Daten, bitte überprüfen Sie die von Ihnen angegebenen Daten',
		error500: 'Server funktioniert nicht, bitte wenden Sie sich an den Administrator',
		errorDateFromRequired: 'Datum erforderlich',
		errorDateToRequired: 'Datum erforderlich',
		errorMinZero: 'darf nicht kleiner 0 sein',
		errorSum: 'Die Summen beider angaben müssen übereinstimmen',
		errorInvalidUrl: 'Adresse ist nicht gültig',
		expandButton: 'Alle erweitern',
		editCompApprovalREQUEST: 'Durch das bearbeiten des Wettkampfs wird der Status auf "In Bearbeitung" gestellt. Vorhandene Genehmigungen werdend daruch wiederrufen. Sind Sie sicher, dass sie fortfahren wollen?',
		event: 'Bewerb',
		eventRegistration: 'Veranstaltungen',
		eventReg: {
			finishedTextAuth: 'Danke für deine Teilnahme, die Teilnahmebestätigung wurde dir per E-Mail zugeschickt. Weitere Informationen findest du in dieser E-Mail. (Bitte prüfe auch deinen Spam-Ordner)',
			finishedTextUnauth: 'Daten wurden erfolgreich übermittelt. Bitte überprüfe deine E-Mails und bestätige die Teilnahme durch klick auf den mitgesandten Link. (Bitte prüfe auch deinen Spam-Ordner)',
		},
		events: 'Bewerbe',
		eventsSelected: ' Bewerbe ausgewählt',
		eventClassDef: 'Bewerb/Klassen-Definition',
		edit: 'Bearbeiten',
		editLow: 'bearbeiten',
		editedFrom: 'Zuletzt geändert von ',
		fax: 'Fax',
		fileTitle: 'Titel',
		fileSort: 'Sortierung',
		fileGroup: 'Gruppe',
		firstTimeEvent: 'Erstveranstaltung',
		forgotPasswordTitle: 'Passwort vergessen',
		forgotPasswordButton: 'Passwort vergessen',
		forgotPasswordSuccess: 'Bitte überprüfen Sie Ihre E-Mails, um Ihr Passwort zurückzusetzen.',
		firstName: 'Vorname',
		filterButton: 'Filter',
		finishButton: 'Fertig',
		finisherNumbers: 'Finisherzahlen erfassen',
		fromDlo: 'nach DLO',
		fromPreset: 'kopieren von anderer Bestenliste',
		fileGroups: {
			tender: 'Ausschreibung',
			online: 'Online-Anmeldung',
			schedule: 'Zeitplan',
			entries: 'Teilnehmer',
			infos: 'Weitere Infrmationen',
			else: 'Sonstiges',
			live: 'Live-Ergebnisse',
			results: 'Ergebnisse',
			moreLA: 'Mehr auf leichtathletik.de',
			elseLA: 'Sonstiges leichtathletik.de',
		},
		gps1: 'GPS (Lat)',
		gps2: 'GPS (Lng)',
		headerHash: '#',
		headerCreatedAt: 'Hergestellt in',
		headerChangedAt: 'Geändert um',
		headerOrganization: 'Organisation',
		headerUser: 'Benutzer',
		headerCompetitor: 'Athlet',
		headerCompetitionName: 'Veranstaltungsname',
		headerCompetitionLocation: 'Austragungsort',
		headerCompetitionDate: 'Austragungsdatum',
		headerContactAddress: 'Kontaktadresse für die Veranstaltung (wird veröffentlicht)',
		headerRole: 'Rolle',
		headerStatus: 'Status',
		headerReason: 'Grund',
		headerActions: 'Aktionen',
		headerOrganizationName: 'Organisationsname',
		headerBestlistName: 'Name',
		headerRegionalRestriction: 'Regionale-Einschränkung',
		headerPerfListName: 'Name der Leistungsliste',
		headerBestResult: 'Resultat',
		headerBestWind: 'Wind',
		headerEventShortNational: 'Bewerb',
		headerHeightWeight: 'Höhe-Gewicht',
		headerPerformanceDateTime: 'Datum',
		headerPerformanceCompetitionName: 'Veranstaltung',
		headerPerformanceCompetitionTown: 'Ort',
		headerPerformanceOrganizationName: 'Verein',
		headerStatisticData: 'Statistische Daten',
		headerName: 'Name',
		headerDateFrom: 'Datum vom',
		headerDateTo: 'Datum bis',
		headerTown: 'Stadt',
		headerLocation: 'Stadion',
		headerNation: 'Nation',
		headerArea: 'Kreis',
		headerDistrict: 'Bezirk',
		headerStateCode: 'LV-Kürzel',
		heightWeight: 'Höhe-Gewicht',
		homepage: 'Website',
		indoor: 'Halle',
		invoice: 'Rechnung',
		invoiceDate: 'Rechnung ausgestellt',
		insertCompetition: 'Veranstaltung beantragen',
		kind: 'Art',
		lastEditedOn: 'Zuletzt bearbeitet am',
		location: 'Ort',
		loginTitle: 'Einloggen',
		login: 'Anmeldung',
		loginHeader: 'Login',
		license: 'Lizenz',
		logout: 'Ausloggen',
		loginButton: 'Anmeldung',
		lastName: 'Nachname',
		language: 'Sprache',
		licenseTitle: 'Lizenz',
		measurementProtocol: 'Vermessungsprotokoll',
		licenseButton: 'Herunterladen',
		masterorganization: 'Dachverband',
		mr: 'Herr',
		mrs: 'Frau',
		mobile: 'Mobil',
		noButton: 'Nein',
		next: 'Weiter',
		none: 'keine',
		newPerformance: 'Neue Leistung',
		newRequestButton: 'Neue Anfrage',
		newBestList: 'Neue Bestenliste',
		newCompetitionApproval: 'Neuer Wettkampf',
		newCompetitionApprovalTitle: 'Neuer Wettkampf',
		newRoleButton: 'Neue Rolle',
		newUserRoleTitle: 'Neue Benutzerrolle',
		newRoleRequestTitle: 'Neue Rollenanforderung',
		newRoleRequestAdminInfo: 'Diese Organisation hat keinen Administrator. Fordern Sie jetzt die Administratorberechtigung an oder bitten Sie den Verband um Hilfe',
		newBestListTitle: 'Neue Bestenliste',
		newPerformanceInfo: 'Neue Leistung wurde erstellt',
		newChecking: 'Neue Prüfung',
		newCheckingTitle: 'Neue Prüfung',
		newCompetitionTitle: 'Neue Veranstaltung',
		newCompetition: 'Neue Veranstaltung',
		newPerformanceTitle: 'Neue Leistung',
		notDecidedChecking: 'Als negativ markieren',
		negativeChecking: 'Als nicht entschieden markieren',
		name: 'Name',
		nation: 'Nation',
		noDataText: 'keine Daten gefunden',
		outdoor: 'Freiluft',
		organization: 'Organisation',
		organisator: 'Veranstalter',
		on: ' am ',
		otherContact: 'andere Adresse eingeben',
		open: 'Offen',
		place: 'Ort',
		zip: 'PLZ',
		password: 'Passwort',
		perfTime: 'Leistungsdatum',
		performance: 'Leistungen',
		performanceTitle: 'Leistungen',
		performanceLoading: 'Leistungen wird geladen',
		performanceList: 'Leistungsliste',
		points: 'Punkte:',
		phone: 'Telefon',
		protocollAtDlvLv: 'Liegt dem DLV und LV vor',
		regMan: 'Stellplatzkarte',
		regMans: 'Stellplatzkarten',
		regManFound: 'Stellplatzkarte erkannt',
		register: 'Registrieren',
		registrations: 'Anmeldungen',
		registerTitle: 'Registrieren',
		registerButton: 'Registrieren',
		registrationSuccess: 'Danke für Ihre Registrierung. Bitte bestätigen Sie die E-Mail die an Sie gesendet wurde.',
		relayMembers: 'Staffel-Teilnehmer',
		resetPasswordTitle: 'Passwort zurücksetzen',
		resetPasswordButton: 'Passwort zurücksetzen',
		resetPasswordSuccess: 'Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort einloggen.',
		rejectRoleRequestTitle: 'Rollenanforderung ablehnen',
		rejectRoleReason: 'Grund',
		rejectButton: 'Ablehnen',
		role: 'Rolle',
		roleRequestsTitle: 'Rollenanfragen',
		roleRequestsLoading: 'Laden, bitte warten',
		rolerequests: 'Rollenanfragen',
		removeRequestNotification: 'Sind Sie sicher, dass Sie löschen möchten?',
		removeRoleButtonInfo: 'Rolle entfernen',
		removeRequestButtonInfo: 'Anfrage entfernen',
		removeRole: 'Sind Sie sicher, dass Sie löschen möchten?',
		removeLastRoles: 'Möchten Sie wirklich alle Rollen für Benutzer löschen:',
		removeRegMan: 'Möchten Sie die Stellplatzkarte aus Ihrer Liste entfernen? Der Abgabestatus der Stellplatzkarte bleibt davon unberührt!',
		redirectPerfList: 'Direktlink zu dieser Bestenliste',
		rejectRequestButtonInfo: 'Anfrage ablehnen',
		regionalRestriction: 'Regionale-Einschränkung',
		reportingPortalLink: 'Link zum Meldeportal',
		onlyStartingPassAllowed: 'Dürfen an dieser Veranstaltung ausschließlich Startpassinhaber teilnehmen?',
		save: 'Speichern',
		scanRegMan: 'Stellplatzkarte scannen',
		scan: 'Scannen',
		spinner: 'Wird bearbeitet...',
		sortButton: 'Sortieren',
		setAge4All: 'Für gesamte Klasse setzen',
		search: 'Suche',
		searchButton: 'Suche',
		searchPeriod: 'Suchzeitraum',
		stadionName: 'Stadion',
		startAge: 'Start-Alter',
		startDate: 'Startdatum',
		startTime: 'Startzeit',
		status: 'Status',
		statistic: 'Statistik',
		stateCode: 'LV-Kürzel',
		streetNr: 'Straße / Hausnummer / Postfach',
		street: 'Straße',
		stopEmails: 'Email-Versand unterdrücken',
		showDetails: 'Details anzeigen',
		startLocation: 'Startplatz',
		stateAssociation: 'Landesverband',
		sum: 'Summe',
		sumOverAll: 'Summe gesamt',
		title: 'Anrede',
		to: 'zu',
		town: 'Stadt',
		type: 'Typ',
		unlimited: 'unbeschränkt',
		undecided: 'noch nicht bearbeitet',
		userManagementTitle: 'Benutzerverwaltung',
		userManagementLoading: 'Laden, bitte warten',
		updateRoleButtonInfo: 'Rolle aktualisieren',
		usermanagement: 'Benutzerverwaltung',
		user: 'Benutzer',
		updateButton: 'Aktualisieren',
		yesButton: 'Ja',
		windResult: 'Wind Ergebnis',
	},
};
